// components/InfoCard.tsx
import React from "react";
import "./style.scss";
const LessonsLearntAI = ({ lessons }) => {
    if (!lessons || lessons.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: "lessons-learnt-ai" }, lessons.map((lesson, index) => {
        var _a, _b, _c;
        return (React.createElement("div", { key: `${(_b = (_a = lesson.title) !== null && _a !== void 0 ? _a : lesson.current_status) !== null && _b !== void 0 ? _b : "lesson"}-${index}`, style: { marginBottom: index !== lessons.length - 1 ? 12 : 0 } },
            React.createElement("p", { className: "lesson-title" },
                index + 1,
                ". ", (_c = lesson.title) !== null && _c !== void 0 ? _c : lesson.current_status),
            lesson.description && (React.createElement("p", { className: "lesson-description" },
                React.createElement("span", { className: "lesson-label" }, "Description: "),
                lesson.description)),
            lesson.title && lesson.current_status && (React.createElement("p", { className: "lesson-status" },
                React.createElement("span", { className: "lesson-label" }, "Current Status: "),
                lesson.current_status)),
            lesson.prior_instances && (React.createElement("p", { className: "lesson-prior-instances" },
                React.createElement("span", { className: "lesson-label" }, "Prior Instances: "),
                lesson.prior_instances))));
    })));
};
export default LessonsLearntAI;
